import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import {
  getJobTitles,
  getAllCompanies,
  getAllRecruitersByCompanyID,
  addCompany,
  addRecruiter,
  addJobTitle,
  updateJobDescriptionDoc,
  createNewJobGroup,
} from '../../../services/apiService';
import { AddStudents } from './_components/AddStudents.jsx';

import { Dropdown, Modal, Icon } from 'semantic-ui-react';
import RichTextEditor from '../job-groups/_components/RichTextEditor.jsx';
import XLSX from 'xlsx';

const CreateJobGroup = () => {
  const history = useHistory();
  const [companyImageFile, setCompanyImageFile] = useState(null);
  const [recruiterImageFile, setRecruiterImageFile] = useState(null);
  const [jobDescriptionDocument, setJobDescriptionDocument] = useState(null);
  const [newCompany, setNewCompany] = useState('');
  const [newRecruiter, setNewRecruiter] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });
  // const [newJobTitle, setNewJobTitle] = useState('');
  const [createJobGroupLoading, setCreateJobGroupLoading] = useState(false);
  const [jobTitles, setJobTitles] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [recruiters, setRecruiters] = useState([]);
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [showRecruiterModal, setShowRecruiterModal] = useState(false);
  const [showAddStudentsForm, setAddStudentsForm] = useState(false);
  const [showAddStudentsFromCSVModal, setShowAddStudentsFromCSVModal] =
    useState(false);
  // const [loading, setLoading] = useState(false);
  const [basicDetails, setBasicDetails] = useState({
    jobTitleId: '',
    jobTitle: '',
    companyId: null,
    companyName: '',
    companyAvatar: '',
    description: '',
  });
  const [recruiterDetails, setRecruiterDetails] = useState({
    recruiterId: '',
    name: '',
    email: '',
    phone: '',
  });
  const [bulkImportedStudents, setBulkImportedStudents] = useState([]);
  const [viewBulkImportedStudentsData, setViewBulkImportedStudentsData] =
    useState([]);
  const [spreadsheetFile, setSpreadSheetFile] = useState(null);
  const spreadsheetFileRef = useRef(null);

  const handleStudentSpreadSheetUpload = async (e) => {
    // e.preventDefault();
    const _file = e.target.files;
    console.log('_file:', _file);
    if (_file.length !== 0) {
      handleFile(_file[0]);
    }
  };
  const handleFile = (file) => {
    const reader = new FileReader();
    const readAsBinary = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      const binaryString = e.target.result;
      const readStream = XLSX.read(binaryString, {
        type: readAsBinary ? 'binary' : 'array',
        cellDates: true,
        dateNF: 'mm/dd/yyyy',
      });
      // Get first worksheet
      const sheetName = readStream.SheetNames[0];
      const _sheet = readStream.Sheets[sheetName];
      // Convert array of arrays
      const sheetData = XLSX.utils.sheet_to_json(_sheet, { header: 1 });
      const studentData = sheetData ?? [];
      studentData.shift(); // returns the headers
      setViewBulkImportedStudentsData(
        studentData.map((student) => {
          return {
            name: student[2],
            email: student[3],
            phone: student[4],
          };
        }) ?? []
      );
      setBulkImportedStudents(
        studentData.map((student) => {
          return student[3];
        }) ?? []
      );
    };
    if (readAsBinary) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  };

  // XLSX code ends here

  // add a new jobTtile
  const addNewJobTitle = async (newTitle) => {
    try {
      // setLoading(true);
      const response = await addJobTitle({ title: newTitle });
      // setLoading(false);
      setJobTitles([...jobTitles, response?.data]);
      setBasicDetails({
        ...basicDetails,
        jobTitleId: response?.data?.jobTitleId,
        jobTitle: response?.data?.title,
      });
      // setNewJobTitle('');
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  };

  // add a new company
  const addNewCompany = React.useCallback(async () => {
    try {
      // setLoading(true);
      const formData = new FormData();
      formData.append('companyName', newCompany);
      formData.append('file', companyImageFile);
      const response = await addCompany(formData);
      // setLoading(false);
      setNewCompany('');
      setCompanyImageFile(null);
      setCompanies([...companies, response?.data]);
      setBasicDetails({
        ...basicDetails,
        companyId: response?.data?.companyId,
        companyName: response?.data?.companyName,
        companyAvatar: response?.data?.companyAvatar,
      });
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  }, [newCompany, companyImageFile, companies]);

  // add a new recruiter
  const addNewRecruiter = React.useCallback(async () => {
    try {
      // setLoading(true);
      const formData = new FormData();
      formData.append('companyId', basicDetails.companyId);
      formData.append('file', recruiterImageFile);
      formData.append('name', newRecruiter.name);
      formData.append('email', newRecruiter.email);
      formData.append('phone', newRecruiter.phone);
      const response = await addRecruiter(formData);
      // setLoading(false);
      setNewRecruiter({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
      });
      setRecruiterImageFile(null);
      setRecruiters([...recruiters, response?.data]);
      setRecruiterDetails({
        ...recruiterDetails,
        recruiterId: response?.data?.recruiterId,
        name: response?.data?.name,
        email: response?.data?.email,
        phone: response?.data?.phone,
      });
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  }, [newRecruiter, recruiterImageFile, recruiters]);

  // fetch job titles and companies
  const fetchBasicDetailOptions = async () => {
    try {
      // setLoading(true);
      const _jobTitles = await getJobTitles();
      const _companies = await getAllCompanies();
      // setLoading(false);
      setJobTitles(_jobTitles?.data ?? []);
      setCompanies(_companies?.data ?? []);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  };

  // fetch recruiters by company id
  const fetchRecruiterDetailOptions = async () => {
    try {
      // setLoading(true);
      const _recruiters = await getAllRecruitersByCompanyID(
        basicDetails.companyId
      );
      // setLoading(false);
      setRecruiters(_recruiters?.data ?? []);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  };

  // fetch job titles on component mount
  useEffect(() => {
    fetchBasicDetailOptions();
  }, []);

  // fetch recruiters on company change
  useEffect(() => {
    if (basicDetails.companyId) {
      fetchRecruiterDetailOptions();
    }
  }, [basicDetails.companyId]);

  const handleAddNewCompany = (companyName) => {
    setShowCompanyModal(true);
    setNewCompany(companyName);
  };

  const toggleShowAddStudents = () => {
    setAddStudentsForm(!showAddStudentsForm);
  };

  const updateJDDoc = async (groupId) => {
    try {
      const formData = new FormData();
      formData.append('groupId', groupId);
      formData.append('file', jobDescriptionDocument);
      await updateJobDescriptionDoc(formData);
    } catch (error) {
      console.log(error);
    }
  };

  // create new job group
  const createJobGroup = async () => {
    try {
      setCreateJobGroupLoading(true);
      const response = await createNewJobGroup({
        companyId: basicDetails.companyId,
        recruiterId: recruiterDetails.recruiterId,
        jobTitleId: basicDetails.jobTitleId,
        students: bulkImportedStudents,
        jobDescription: basicDetails.description,
        studentArrayType: 'email',
      });
      if (jobDescriptionDocument) {
        updateJDDoc(response.data.groupId);
      }
      setCreateJobGroupLoading(false);
      history.push(`/job-dashboardv2/job-groups`);
    } catch (error) {
      setCreateJobGroupLoading(false);
      console.log(error);
    }
  };

  const renderCreateJobGroupScreen = () => {
    if (showAddStudentsForm) {
      return (
        <AddStudents
          basicDetails={basicDetails}
          recruiterDetails={recruiterDetails}
          jobDescriptionDocument={jobDescriptionDocument}
        />
      );
    }

    return (
      <form className='w-full  bg-white px-10 py-10'>
        <div className='flex-col items-center justify-between'>
          <h1 className='user-heading text-3xl font-semibold mt-5'>
            Create Job Group
          </h1>
          <p className='font-light mb-5'>
            fill the details to create a job group.
          </p>
        </div>
        <h2 className='user-heading text-lg font-semibold mt-5'>
          Basic Details
        </h2>
        <hr className='border-6 mb-5 ' />
        <div className='flex flex-wrap -mx-3 mb-6'>
          <div className='w-full md:w-1/2 px-3 mb-6 md:mb-0'>
            <label
              className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
              htmlFor='grid-state'
            >
              Job Title
            </label>
            <Dropdown
              options={jobTitles.map((jobTitle) => ({
                key: jobTitle.jobTitleId,
                text: jobTitle.title,
                value: jobTitle.jobTitleId,
              }))}
              onChange={(e, { value, text }) => {
                // find the job title by id from the list of job titles
                const _jobTitle = jobTitles.find(
                  (job) => job.jobTitleId === value
                );
                setBasicDetails({
                  ...basicDetails,
                  jobTitleId: value,
                  jobTitle: _jobTitle?.title ?? '',
                });
              }}
              placeholder='Choose a job title or create a new one'
              search
              selection
              fluid
              allowAdditions
              value={basicDetails.jobTitleId || ''}
              onAddItem={(e, { value }) => {
                addNewJobTitle(value);
              }}
            />
          </div>
          <div className='w-full md:w-1/2 px-3'>
            <label
              className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
              htmlFor='grid-state'
            >
              Company Name
            </label>
            <Dropdown
              options={companies.map((company) => ({
                key: company.companyId,
                text: company.companyName,
                value: company.companyId,
                image: { avatar: true, src: company.companyAvatar },
              }))}
              onChange={(e, { value, text }) => {
                // find the company details from the companies array
                const _company = companies.find(
                  (company) => company.companyId === value
                );
                setBasicDetails({
                  ...basicDetails,
                  companyId: value,
                  companyName: _company?.companyName ?? '',
                  companyAvatar: _company?.companyAvatar ?? '',
                });

                // reset recruiter details
                setRecruiterDetails({
                  ...recruiterDetails,
                  recruiterId: '',
                  name: '',
                  email: '',
                  phone: '',
                });
              }}
              placeholder='Choose a company or create a new one'
              search
              selection
              fluid
              allowAdditions
              value={basicDetails.companyId || ''}
              onAddItem={(e, { value }) => {
                handleAddNewCompany(value);
              }}
            />
          </div>
        </div>
        <div className='flex flex-wrap -mx-3 mb-6'>
          <div className='w-2/3 px-3' style={{ flex: 0.5 }}>
            <label
              className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
              htmlFor='grid-password'
            >
              Job Description
            </label>
            <div className='w-full'>
              <RichTextEditor
                initialValue=''
                getValue={(value) => {
                  setBasicDetails({
                    ...basicDetails,
                    description: value,
                  });
                }}
              />
            </div>
          </div>
          <div className='w-1/3 px-3' style={{ flex: 0.5 }}>
            <label
              htmlFor='pdf'
              type='button'
              className='w-full flex h-full justify-end items-end '
            >
              <div
                className='w-full h-80 flex flex-col items-center justify-center border-2 border-dashed '
                onDragOver={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const file = e.dataTransfer.files[0];
                  setJobDescriptionDocument(file);
                }}
              >
                <div className='flex flex-col items-center justify-center'>
                  <div className='text-2xl mb-10'>Upload JD Document</div>
                  <div className='flex items-center justify-center'>
                    <i className='fas fa-file-pdf text-5xl text-brand-primary' />
                  </div>

                  {jobDescriptionDocument && (
                    <div className='text-sm mt-5'>
                      {jobDescriptionDocument.name} uploaded
                      <i
                        className='fas fa-times ml-2 text-gray-400'
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setJobDescriptionDocument(null);
                        }}
                      />
                    </div>
                  )}
                  {!jobDescriptionDocument && (
                    <p className='text-sm text-gray-400'>
                      <span className='font-medium text-gray-600'>
                        Drag and drop your file here
                      </span>
                    </p>
                  )}
                  <p className='text-xs text-gray-400 mt-1'>
                    Supported file type : PDF
                  </p>

                  <div
                    type='button'
                    className='mt-2 bg-gray-300 text-black p-2'
                  >
                    Choose File
                  </div>
                </div>
              </div>
            </label>
            <input
              type='file'
              id='pdf'
              style={{ visibility: 'hidden', width: '0px' }}
              onChange={(e) => {
                setJobDescriptionDocument(e.target.files[0]);
              }}
            />
          </div>
        </div>

        <h2 className='user-heading text-lg font-semibold mt-5'>
          Recruiter Details
        </h2>
        <hr className='border-6 mb-5 ' />
        <div className='flex flex-wrap -mx-3 mb-2'>
          <div className='w-full md:w-1/3 px-3 mb-6 md:mb-0'>
            <label
              className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
              htmlFor='grid-city'
            >
              Recruiter Name
            </label>

            <Dropdown
              options={recruiters.map((recruiter) => ({
                key: recruiter.recruiterId,
                text: recruiter.name,
                value: recruiter.recruiterId,
                image: { avatar: true, src: recruiter.avatar },
              }))}
              onChange={(e, { value, text, email, phone }) => {
                // find the recruiter in the list of recruiters
                const _recruiter = recruiters.find(
                  (recruiter) => recruiter.recruiterId === value
                );
                setRecruiterDetails({
                  ...recruiterDetails,
                  recruiterId: value,
                  name: _recruiter?.name ?? '',
                  email: _recruiter?.email ?? '',
                  phone: _recruiter?.phone ?? '',
                });
              }}
              placeholder='Recruiter Name'
              search
              disabled={!basicDetails.companyId}
              selection
              fluid
              allowAdditions
              value={recruiterDetails.recruiterId || ''}
              onAddItem={(e, { value }) => {
                setNewRecruiter({ ...newRecruiter, name: value });
                setShowRecruiterModal(true);
              }}
            />
          </div>

          <div className='w-full md:w-1/3 px-3 mb-6 md:mb-0'>
            <label
              className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
              htmlFor='grid-zip'
            >
              Email
            </label>
            <input
              className='appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
              id='grid-zip'
              type='email'
              value={recruiterDetails.email || ''}
              disabled={true}
              placeholder='recruiter email'
            />
          </div>
          <div className='w-full md:w-1/3 px-3 mb-6 md:mb-0'>
            <label
              className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
              htmlFor='grid-zip'
            >
              Mobile Number
            </label>
            <input
              className='appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
              id='grid-zip'
              type='number'
              value={recruiterDetails.phone || ''}
              disabled={true}
              placeholder='91+'
            />
          </div>
        </div>
        <h2 className='user-heading text-lg font-semibold mt-5'>
          Bulk import students
        </h2>
        <hr className='border-6 mb-5 ' />
        <div className='flex flex-wrap -mx-3 mb-6'>
          <div className='w-full px-3 mb-6 md:mb-0'>
            <div className='flex flex-wrap mb-2 mt-8 justify-start items-center w-full'>
              <div className='flex justify-center items-center border rounded '>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    spreadsheetFileRef.current.click();
                  }}
                  className='font-semibold bg-gray-300 px-5 py-2 rounded text-white hover:bg-gray-400'
                  style={{ backgroundColor: '#1C5DDB' }}
                >
                  Upload
                  <span className='ml-2'>
                    <Icon name='upload' />
                  </span>
                </button>
                <p className='text-gray-500 text-xs italic mx-5'>
                  {spreadsheetFile?.length > 0
                    ? spreadsheetFile[0].name
                    : 'No file chosen'}
                </p>
              </div>
              <button className='mx-3'>
                <Icon
                  onClick={(e) => {
                    e.preventDefault();
                    setSpreadSheetFile([]);
                    setBulkImportedStudents([]);
                    setViewBulkImportedStudentsData([]);
                  }}
                  name='trash alternate outline'
                />
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setShowAddStudentsFromCSVModal(true);
                }}
                disabled={bulkImportedStudents.length === 0}
              >
                <Icon
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  name='eye'
                />
              </button>
            </div>

            <input
              onChange={(e) => {
                setSpreadSheetFile(e.target.files);
                handleStudentSpreadSheetUpload(e);
              }}
              type='file'
              ref={spreadsheetFileRef}
              hidden={true}
              accept='.csv, .xlsx'
            />
          </div>
        </div>
        <div className='flex flex-wrap -mx-3 mb-2 mt-8 justify-center'>
          <button
            onClick={() => {
              history.push(`/job-dashboardv2/job-groups`);
            }}
            className=' text-base font-medium text-gray border border-primary-400 px-8 py-2 ml-8 rounded'
          >
            Cancel
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (bulkImportedStudents.length > 0 && !createJobGroupLoading) {
                createJobGroup();
              } else {
                toggleShowAddStudents();
              }
            }}
            disabled={
              createJobGroupLoading ||
              !basicDetails.companyId ||
              !basicDetails.jobTitleId ||
              !recruiterDetails.recruiterId
            }
            className={`${
              createJobGroupLoading ||
              !basicDetails.companyId ||
              !basicDetails.jobTitleId ||
              !recruiterDetails.recruiterId
                ? 'bg-red-500 cursor-not-allowed'
                : 'bg-brand-primary'
            } text-base font-medium text-white border border-primary-400 px-8 py-2 ml-8 rounded`}
          >
            {bulkImportedStudents.length > 0 ? (
              <span>
                {createJobGroupLoading
                  ? 'Creating job group...'
                  : 'Create Job Group'}
              </span>
            ) : (
              'Add Students'
            )}
          </button>
        </div>

        {/* Start Of Create Company Modal */}
        <Modal
          onClose={() => setShowCompanyModal(false)}
          onOpen={() => setShowCompanyModal(true)}
          open={showCompanyModal}
        >
          <Modal.Header>Add a new company</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <div className='flex flex-wrap justify-start mb-2'>
                <div className='flex relative'>
                  <label
                    htmlFor='file'
                    type='button'
                    className='w-20 h-20 bg-red-50 rounded-full border-2  cursor-pointer ring-gray-900 ring-1'
                    style={{
                      backgroundImage: `url(${
                        companyImageFile
                          ? URL.createObjectURL(companyImageFile)
                          : ''
                      })`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center center',
                    }}
                  />
                  <Icon
                    name='pencil alternate'
                    style={{
                      position: 'absolute',
                      bottom: '15px',
                      right: '10px',
                    }}
                  />
                  <input
                    type='file'
                    id='file'
                    style={{ visibility: 'hidden', width: '0px' }}
                    onChange={(e) => {
                      setCompanyImageFile(e.target.files[0]);
                    }}
                  />
                </div>
                <div className='w-full flex-2 md:w-1/3 px-3 mb-6 md:mb-0'>
                  <label
                    className='block tracking-wide text-gray-700 text-xs font-bold mb-2'
                    htmlFor='grid-zip'
                  >
                    Company Name
                  </label>
                  <input
                    className='appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                    id='grid-zip'
                    type='text'
                    value={newCompany}
                    onChange={(e) => {
                      setNewCompany(e.target.value);
                    }}
                    placeholder='Type in the name of the company'
                  />
                </div>
              </div>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <button
              onClick={() => {
                setShowCompanyModal(false);
              }}
              className=' text-base font-medium text-gray border border-primary-400 px-8 py-2 ml-8 rounded'
            >
              Cancel
            </button>
            <button
              onClick={() => {
                setShowCompanyModal(false);
                addNewCompany();
              }}
              className='bg-brand-primary text-base font-medium text-white border border-primary-400 px-8 py-2 ml-8 rounded'
            >
              Add Company
            </button>
          </Modal.Actions>
        </Modal>

        {/* End Of Create Company Modal */}
        {/* Start Of Add Recruiter Modal */}
        <Modal
          onClose={() => setShowRecruiterModal(false)}
          onOpen={() => setShowRecruiterModal(true)}
          open={showRecruiterModal}
        >
          <Modal.Header>Add a new Recruiter</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <div className='flex flex-wrap justify-start mb-2'>
                <div className='flex relative'>
                  <label
                    htmlFor='file'
                    type='button'
                    className='w-20 h-20 bg-red-50 rounded-full border-2  cursor-pointer ring-gray-900 ring-1'
                    style={{
                      backgroundImage: `url(${
                        recruiterImageFile
                          ? URL.createObjectURL(recruiterImageFile)
                          : ''
                      })`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center center',
                    }}
                  />
                  <Icon
                    name='pencil alternate'
                    style={{
                      position: 'absolute',
                      bottom: '15px',
                      right: '10px',
                    }}
                  />
                  <input
                    type='file'
                    id='file'
                    style={{ visibility: 'hidden', width: '0px' }}
                    onChange={(e) => {
                      setRecruiterImageFile(e.target.files[0]);
                    }}
                  />
                </div>
                <div className='w-full flex-2 md:w-1/3 px-3 mb-6 md:mb-0'>
                  <label
                    className='block tracking-wide text-gray-700 text-xs font-bold mb-2'
                    htmlFor='grid-zip'
                  >
                    Recruiter Name
                  </label>
                  <input
                    className='appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                    id='grid-zip'
                    type='text'
                    value={newRecruiter.name}
                    onChange={(e) => {
                      setNewRecruiter({
                        ...newRecruiter,
                        name: e.target.value,
                      });
                    }}
                    placeholder='Type in the name of the Recruiter'
                  />
                </div>
                <div className='w-full flex-2 md:w-1/3 px-3 mb-6 md:mb-0'>
                  <label
                    className='block tracking-wide text-gray-700 text-xs font-bold mb-2'
                    htmlFor='grid-zip'
                  >
                    Email
                  </label>
                  <input
                    className='appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                    id='grid-zip'
                    type='text'
                    value={newRecruiter.email}
                    onChange={(e) => {
                      setNewRecruiter({
                        ...newRecruiter,
                        email: e.target.value,
                      });
                    }}
                    placeholder='Enter email address'
                  />
                </div>
                <div className='w-full flex-2 md:w-1/3 px-3 mb-6 md:mb-0 mt-6'>
                  <label
                    className='block tracking-wide text-gray-700 text-xs font-bold mb-2'
                    htmlFor='grid-zip'
                  >
                    Mobile Number
                  </label>
                  <input
                    className='appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                    id='grid-zip'
                    type='number'
                    value={newRecruiter.phone}
                    onChange={(e) => {
                      setNewRecruiter({
                        ...newRecruiter,
                        phone: e.target.value,
                      });
                    }}
                    placeholder='Enter mobile number'
                  />
                </div>
              </div>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <button
              onClick={() => {
                setNewRecruiter({
                  firstName: '',
                  lastName: '',
                  email: '',
                  phone: '',
                });
                setRecruiterImageFile(null);
                setShowRecruiterModal(false);
                setRecruiterDetails({
                  recruiterId: '',
                  name: '',
                  email: '',
                  phone: '',
                });
              }}
              className=' text-base font-medium text-gray border border-primary-400 px-8 py-2 ml-8 rounded'
            >
              Cancel
            </button>
            <button
              onClick={() => {
                setShowRecruiterModal(false);
                addNewRecruiter();
              }}
              className='bg-brand-primary text-base font-medium text-white border border-primary-400 px-8 py-2 ml-8 rounded'
            >
              Add Recruiter
            </button>
          </Modal.Actions>
        </Modal>
        {/* End Of Add Recruiter Modal */}
        {/* Start Of Add Students from CSV Modal */}
        <Modal
          onClose={() => setShowAddStudentsFromCSVModal(false)}
          onOpen={() => setShowAddStudentsFromCSVModal(true)}
          open={showAddStudentsFromCSVModal}
        >
          <Modal.Header>Add Students</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <div className='flex flex-wrap justify-start mb-2'>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                    <TableHead>
                      <TableRow>
                        <TableCell>Sl no.</TableCell>
                        <TableCell>Students</TableCell>
                        <TableCell align='right'>email</TableCell>
                        <TableCell align='right'>phone</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {viewBulkImportedStudentsData.map((row, index) => (
                        <TableRow
                          key={row.email}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                          }}
                        >
                          <TableCell component='th' scope='row'>
                            {index + 1}
                          </TableCell>
                          <TableCell align='right'>{row.name}</TableCell>
                          <TableCell align='right'>{row.email}</TableCell>
                          <TableCell align='right'>{row.phone}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowAddStudentsFromCSVModal(false);
              }}
              className=' text-base font-medium text-gray border border-primary-400 px-8 py-2 ml-8 rounded'
            >
              Cancel
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowAddStudentsFromCSVModal(false);
              }}
              className='bg-brand-primary text-base font-medium text-white border border-primary-400 px-8 py-2 ml-8 rounded'
            >
              Confirm
            </button>
          </Modal.Actions>
        </Modal>
        {/* End Of Add Students Modal */}
      </form>
    );
  };

  return <div>{renderCreateJobGroupScreen()} </div>;
};

export default CreateJobGroup;
